import React from 'react';
import Modal from 'react-bootstrap/Modal';
import type { AppFile } from './models/JobSharedInterfaces';

interface JobPhotoViewerProps {
    photoList: PhotoItem[];
    origDateIndex: number;
    origPhotoIndex: number;
    showModal: boolean;
    hideModal(): void;
}

interface PhotoItem {
    insertedDateFormatted: string;
    photos: AppFile[];
}

const JobPhotoViewerData = (props: JobPhotoViewerProps) => {
    const [photoIndex, setPhotoIndex] = React.useState(0);
    const [dateIndex, setDateIndex] = React.useState(0);
    const [pos, setPos] = React.useState({ x: 0, y: 0, scale: 1 });
    const [panning, setPanning] = React.useState(false);
    const [start, setStart] = React.useState({ x: 0, y: 0 });

    React.useEffect(() => {
        window.scrollTo(0, 0);

        setDateIndex(props.origDateIndex);
        setPhotoIndex(props.origPhotoIndex);
    }, [props.origDateIndex, props.origPhotoIndex]);

    const hideModal = () => {
        resetPosition();
        props.hideModal();
    }

    const goNext = (e: any) => {
        e.preventDefault();

        resetPosition();

        //need to check if we have made it to the end of the photos
        var photoDateLength = props.photoList.length;
        var photoItemLength = props.photoList[dateIndex].photos.length;

        if (photoDateLength > 0 && (photoIndex + 1) < photoItemLength) {
            //go to next photo in the list for this date
            setPhotoIndex(photoIndex + 1);
        } else if ((dateIndex + 1) < photoDateLength) {
            //go to the first photo for the next date
            setDateIndex(dateIndex + 1);
            setPhotoIndex(0);
        } else {
            //go to the first photo in the first date
            setDateIndex(0);
            setPhotoIndex(0);
        }
    }

    const goPrev = (e: any) => {
        e.preventDefault();

        resetPosition();

        //need to check if we have made it to the start of the photos
        var photoDateLength = props.photoList.length;

        if (photoDateLength > 0 && photoIndex > 0) {
            //go to previous photo in the list for this date
            setPhotoIndex(photoIndex - 1);
        } else if (dateIndex > 0) {
            //go to the last photo in the previous date
            var newDateIndex = dateIndex - 1;
            setDateIndex(newDateIndex);
            //calculate number of photos in the new date
            var newDateLength = props.photoList[newDateIndex].photos.length;
            var newInd = newDateLength === 0 ? 0 : newDateLength - 1;
            setPhotoIndex(newInd);
        } else {
            //go to the last photo in the last date
            var newDateInd = photoDateLength === 0 ? 0 : photoDateLength - 1;
            setDateIndex(newDateInd);
            //get number of photos for new date
            let photoInd = props.photoList[newDateInd].photos.length === 0 ? 0 : props.photoList[newDateInd].photos.length - 1;
            setPhotoIndex(photoInd);
        }
    }

    const onmousedown = (e: any) => {
        e.preventDefault();
        let start = { x: e.clientX - pos.x, y: e.clientY - pos.y };
        setPanning(true);
        setStart(start);
    }

    const onmouseup = (e: any) => {
        e.preventDefault();
        setPanning(false);
    }

    const onmousemove = (e: any) => {
        e.preventDefault();
        if (!panning) {
            return;
        }
        let pointX = (e.clientX - start.x);
        let pointY = (e.clientY - start.y);

        setPos(prevState => ({ ...prevState, "x": pointX, "y": pointY }));
    }

    const onwheel = (e: any) => {
        var xs = (e.clientX - pos.x) / pos.scale,
            ys = (e.clientY - pos.y) / pos.scale,
            delta = (e.wheelDelta ? e.wheelDelta : -e.deltaY);

        var newScale = pos.scale;
        if (delta > 0) {
            newScale = pos.scale * 1.2;
        } else {
            newScale = pos.scale / 1.2;
        }

        if (newScale > 1) {
            let pointX = e.clientX - xs * newScale;
            let pointY = e.clientY - ys * newScale;

            setPos(prevState => ({ ...prevState, x: pointX, y: pointY, scale: newScale }));
        } else {
            resetPosition();
        }
        
    }

    //reset when changing photos
    const resetPosition = () => {
        setPos({ x: 0, y: 0, scale: 1 });
        setPanning(false);
        setStart({ x: 0, y: 0 });
    }

    return (
        <Modal show={props.showModal} size="xl" onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Photos</Modal.Title>
                <button type="button" className="close modal__close--colour" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div><h1>{props.photoList.length === 0 ? "" : props.photoList[dateIndex].insertedDateFormatted }</h1></div>
                    <div className="jobPhotoViewer--height makeitflexspacebetween">
                        <a className="jobPhotoViewerNext makeitcentervertical" href="#" onClick={(e) => goPrev(e)}>
                            <i className="fa-solid fa-chevron-left "></i>
                        </a>
                        <div className={props.photoList.length === 0 ? "hidden" : "overflowHidden"}>
                            <div className="" style={{ cursor: "grab", transformOrigin: "0 0", transform: `translate(${pos.x}px, ${pos.y}px) scale(${pos.scale})` }} onWheelCapture={onwheel} onMouseMove={onmousemove} onMouseUp={onmouseup} onMouseDown={onmousedown}>
                                <img className="jobPhotoViewerPhoto--size" src={props.photoList.length === 0 ? "" : props.photoList[dateIndex].photos[photoIndex].id > 0 ? "data:" + props.photoList[dateIndex].photos[photoIndex].fileType + ";base64," + props.photoList[dateIndex].photos[photoIndex].content : props.photoList[dateIndex].photos[photoIndex].content} alt="photos"></img>
                            </div>
                        </div>
                        <a className="jobPhotoViewerNext makeitcentervertical" href="#" onClick={(e) => goNext(e)}>
                            <i className="fa-solid fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--yes" onClick={hideModal}>Close</button>
            </Modal.Footer>
        </Modal>
    );

}

export default JobPhotoViewerData;